<div class="avatar" [style.background-image]="'url(' + this.image + ')'">
    <h3 class="initial-text" *ngIf="this.image == undefined">{{this.initials}}</h3>
</div>